"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpText = void 0;
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const text_html_1 = __importDefault(require("./text.html"));
let ItpText = class ItpText extends vue_property_decorator_1.Vue {
    isCollapsed;
    id;
    tag;
    text;
    defaultText;
    spacing;
    strikethrough;
    strong;
    small;
    pre;
    muted;
    uppercase;
    lowercase;
    capitalize;
    block;
    noWrap;
    wrap;
    tooltip;
    collapsible;
    collapsibleDefaultState;
    collapsibleCollapsedCharsLength;
    data() {
        return {
            isCollapsed: this.collapsibleDefaultState === 'collapsed'
        };
    }
    get displayTooltip() {
        if (!this.tooltip && this.collapsible && this.isCollapsed) {
            if (this.text == null || this.text === '') {
                return this.defaultText || '';
            }
            return this.text;
        }
        return this.tooltip;
    }
    get displayToggle() {
        return this.collapsible;
    }
    get toggleIcon() {
        return this.isCollapsed ? 'mdi:caret-down' : 'mdi:caret-up';
    }
    toggle($event) {
        if (this.collapsible) {
            this.isCollapsed = !this.isCollapsed;
        }
    }
    get componentName() {
        if (this.tag) {
            return this.tag;
        }
        if (this.strong) {
            return 'strong';
        }
        if (this.small) {
            return 'small';
        }
        if (this.strikethrough) {
            return 's';
        }
        return 'span';
    }
    get className() {
        const result = {
            'text-muted': this.muted,
            'd-block': this.block,
            'text-nowrap': this.noWrap && !this.pre && !this.wrap,
            'text-wrap': this.wrap,
            'text-lowercase': this.lowercase,
            'text-uppercase': this.uppercase,
            'text-capitalize': this.capitalize,
            'overflow-hidden': true,
            'text-truncate': true,
        };
        if (!_.isEmpty(this.text) && this.spacing) {
            result[this.spacing] = true;
        }
        if (_.isEmpty(this.text) && this.spacing && this.$slots.default) {
            result[this.spacing] = true;
        }
        return result;
    }
    get displayText() {
        if (this.text == null || this.text === '') {
            return this.defaultText || '';
        }
        if (this.collapsible && this.isCollapsed) {
            let result = this.text.split('\n')[0];
            if (this.collapsibleCollapsedCharsLength) {
                result = _.truncate(result, {
                    length: this.collapsibleCollapsedCharsLength
                });
            }
            return `${result}...`;
        }
        return this.text;
    }
    get style() {
        if (this.pre) {
            return 'white-space: pre-line';
        }
    }
};
exports.ItpText = ItpText;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpText.prototype, "id", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpText.prototype, "tag", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpText.prototype, "text", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpText.prototype, "defaultText", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpText.prototype, "spacing", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpText.prototype, "strikethrough", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpText.prototype, "strong", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpText.prototype, "small", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpText.prototype, "pre", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpText.prototype, "muted", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpText.prototype, "uppercase", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpText.prototype, "lowercase", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpText.prototype, "capitalize", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpText.prototype, "block", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpText.prototype, "noWrap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpText.prototype, "wrap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpText.prototype, "tooltip", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpText.prototype, "collapsible", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'collapsed' }),
    __metadata("design:type", String)
], ItpText.prototype, "collapsibleDefaultState", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: Number }),
    __metadata("design:type", Number)
], ItpText.prototype, "collapsibleCollapsedCharsLength", void 0);
exports.ItpText = ItpText = __decorate([
    (0, vue_property_decorator_1.Component)({ template: text_html_1.default })
], ItpText);
//# sourceMappingURL=text.js.map